import React, { useState } from 'react'
import '../../../Dashboard/css/swap.css';
import '../../../Dashboard/css/addliquidity.css'
import '../../../Dashboard/css/removeliquidity.css'
import { Container, Row, Col, Card, Nav, Form, Button, Tabs, Tab, Modal, InputGroup, Toast, Dropdown, DropdownButton } from 'react-bootstrap';
import RangeSlider from 'react-bootstrap-range-slider';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { Warning } from '../../../../utils/errors';
import web3Config from '../../../Web3/web3Config';



export const Removeliquidity = ({ userLpToken, usdtPriceInInfi, infiPriceInUsdt, closeModal, removeLiquidity }) => {
    const [value, setValue] = React.useState(25);
    const [removedLiquidity, setRemovedLiquidity] = useState("");

    const removeLiquidityNow = async (LpToken) => {
        if (parseFloat(LpToken) == 0) {
            return;
        }
        const removeLpRes = await removeLiquidity(LpToken);

        if (removeLpRes.status) {
            setRemovedLiquidity(removeLpRes.hash)
            // setRemoveLiquidityModal(false)
        } else {
            Warning(removeLpRes.message)
        }
    }

    return (
        <>
            {/* <Header /> */}

            {/* <div className='subheader'>
                <img src='assets/images/liquidity_banner.png' width={`100%`} />
            </div> */}
            {/* <div className="dashboard pt-5 pb-5 position-relative">

                <section className="pb-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={6}> */}
            <div className="ExchangeForm mt-0" >
                <Row>
                    <Col lg={12}>
                        <div className='text-center mb-5'>
                            <div><h4 className='mb-0'>Remove Liquidity</h4></div>
                        </div>
                        {/* <Toast className='w-100 rounded-4 mb-4' bg="primary">
                                                <Toast.Body className='fs-6'>Tip: Removing pool tokens converts your position back into underlying tokens at the current rate, proportional to your share of the pool. Accrued fees are included in the amounts you receive.</Toast.Body>
                                            </Toast> */}
                        {/* <div className='mb-0 dropdown-custom text-right'>
                                                <DropdownButton id="dropdown-basic-button" title="Detailed">
                                                    <Dropdown.Item href="#">
                                                        <div className='d-flex justify-content-between'>
                                                            <div>
                                                                Max. Slippage
                                                            </div>
                                                            <div>
                                                                1%
                                                            </div>

                                                        </div>

                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="#">
                                                        <div className='d-flex justify-content-between'>
                                                            <div>
                                                                Auto &nbsp;<a href='#' className='text-blue small text-decoration-none'>Custom</a>
                                                            </div>
                                                            <div>
                                                                1%
                                                            </div>

                                                        </div>
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="#">
                                                        <div className='d-flex justify-content-between'>
                                                            <div>
                                                                Transaction Deadline
                                                            </div>
                                                            <div>
                                                                20m
                                                            </div>

                                                        </div>
                                                    </Dropdown.Item>
                                                </DropdownButton>

                                            </div> */}

                        <div className='mb-4'>
                            <Form>
                                <Form.Group as={Row}>
                                    <Col xs="12" className=''>
                                        {/* <Form.Control value={value} className='text-center bg-transparent border-0 fs-1' disabled /> */}
                                        <h3 className='text-center bg-transparent border-0 fs-1'>{value}%</h3>
                                    </Col>
                                    <Col xs="12" className='range-custom-slider'>
                                        <RangeSlider
                                            className='w-100'
                                            value={value}
                                            onChange={e => setValue(e.target.value == 0 ? 1 : e.target.value)}
                                            variant='success'
                                        />
                                    </Col>

                                </Form.Group>
                            </Form>
                        </div>
                        <div className='mb-4'>
                            <Card className='cardBox p-3'>
                                <Row className='justify-content-between'>
                                    <Col lg={6} md={6} xs={12}>
                                        <div className="lh-1">
                                            <p className='small mb-0'>LP Token Balance:</p>
                                        </div>
                                    </Col>
                                    <br />
                                    <Col lg={6} md={6} xs={12} className='text-right'>
                                        <div className='lh-1'>
                                            <p className='small mb-2'>{userLpToken} LP</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} md={6} xs={12}>
                                        <div className="lh-1">
                                            <p className='small mb-0'>Remove LP:</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} md={6} xs={12} className='text-right'>
                                        <div className='lh-1'>
                                            <p className='small mb-2'>{parseFloat(userLpToken) * parseInt(value) / 100} LP</p>
                                        </div>
                                    </Col>

                                    <br />
                                    <Col lg={6} md={6} xs={12}>
                                        <div className="lh-1">
                                            <p className='small mb-0'>Price:</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} md={6} xs={12} className='text-right'>
                                        <div className='lh-1'>
                                            <p className='small mb-2'>1 INFI = {infiPriceInUsdt} USDT</p>
                                            <p className='small mb-0'>1 USDT = {usdtPriceInInfi} INFI</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='mt-3'>
                                    <Col lg={6} md={6} xs={6} className=''>
                                        <Button variant='outline-secondary' onClick={() => closeModal()} className='w-100 text-white'>Cancel</Button>
                                    </Col>
                                    <Col lg={6} md={6} xs={6} className=''>
                                        <Button className='w-100 text-black' onClick={() => removeLiquidityNow(parseFloat(userLpToken) * parseInt(value) / 100)}>Remove</Button>
                                    </Col>

                                </Row>
                            </Card>
                        </div>




                        {/* ------------------- */}

                        {/* <Container className='pricepool'>
                                                    <div className='mb-3'>
                                                        <h5 className='mb-0'>Your Position</h5>
                                                    </div>
                                                    <Row className='align-items-center'>
                                                        <Col lg={6} md={6} xs={8} className='mb-2'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='me-2'>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 54 54" fill="none">
                                                                        <circle cx="26.963" cy="26.963" r="26.963" fill="#D9D9D9" />
                                                                        <path d="M11.7109 34.185V23.342H15.8132C16.2369 23.342 16.6927 23.3741 17.1806 23.4383C17.6685 23.4897 18.1243 23.6116 18.548 23.8042C18.9717 23.984 19.3183 24.2665 19.588 24.6516C19.8576 25.0368 19.9924 25.5568 19.9924 26.2116C19.9924 26.6225 19.909 27.0077 19.742 27.3672C19.588 27.7139 19.2991 27.9963 18.8754 28.2146C18.4517 28.4329 17.8482 28.5548 17.065 28.5805V28.6576C17.9766 28.6704 18.6764 28.7988 19.1643 29.0427C19.665 29.2867 20.0117 29.6077 20.2043 30.0057C20.3969 30.3909 20.4932 30.821 20.4932 31.2961C20.4932 31.9766 20.3455 32.5094 20.0502 32.8946C19.7549 33.2798 19.3761 33.5687 18.9139 33.7613C18.4517 33.941 17.9574 34.0566 17.4309 34.1079C16.9174 34.1593 16.4295 34.185 15.9672 34.185H11.7109ZM13.2902 27.9642H15.6206C16.147 27.9642 16.6156 27.9385 17.0265 27.8872C17.4502 27.823 17.784 27.6753 18.028 27.4442C18.2719 27.2131 18.3939 26.8536 18.3939 26.3657C18.3939 25.8393 18.2655 25.4605 18.0087 25.2294C17.7519 24.9855 17.4117 24.8314 16.988 24.7672C16.5643 24.703 16.1149 24.6709 15.6398 24.6709H13.2902V27.9642ZM13.2902 32.8753H15.8324C16.3845 32.8753 16.8853 32.8432 17.3346 32.779C17.784 32.702 18.1435 32.5415 18.4132 32.2976C18.6956 32.0408 18.8369 31.6427 18.8369 31.1035C18.8369 30.5514 18.6892 30.1405 18.3939 29.8709C18.1114 29.6013 17.7262 29.4279 17.2383 29.3509C16.7633 29.261 16.2433 29.2161 15.6783 29.2161H13.2902V32.8753Z" fill="white" />
                                                                        <path d="M26.7876 34.4546C25.2982 34.4546 24.1555 34.0309 23.3595 33.1835C22.5763 32.3232 22.1847 31.1163 22.1847 29.5627V23.342H23.8602V29.5435C23.8602 30.3781 23.995 31.0457 24.2647 31.5465C24.5343 32.0344 24.8874 32.3874 25.3239 32.6057C25.7733 32.824 26.2612 32.9331 26.7876 32.9331C27.3654 32.9331 27.8726 32.8304 28.3091 32.625C28.7585 32.4067 29.1052 32.0536 29.3491 31.5657C29.6059 31.065 29.7343 30.3909 29.7343 29.5435V23.342H31.4098V29.5627C31.4098 31.142 31.0182 32.3553 30.235 33.2027C29.4647 34.0373 28.3155 34.4546 26.7876 34.4546Z" fill="white" />
                                                                        <path d="M37.7064 34.4161C36.9232 34.4161 36.1721 34.2941 35.4531 34.0502C34.7341 33.7934 34.1435 33.3953 33.6812 32.8561C33.2319 32.304 33.0007 31.5914 32.9879 30.7183H34.6057C34.6057 30.7697 34.6249 30.9173 34.6635 31.1613C34.7148 31.3924 34.8368 31.6492 35.0294 31.9316C35.2348 32.2013 35.5558 32.4388 35.9923 32.6442C36.4289 32.8497 37.0388 32.9524 37.822 32.9524C38.4511 32.9524 38.9454 32.8625 39.3049 32.6827C39.6773 32.503 39.9341 32.2911 40.0753 32.0472C40.2294 31.8032 40.3128 31.585 40.3257 31.3924C40.3257 30.9944 40.1973 30.6734 39.9405 30.4294C39.6965 30.1855 39.3627 29.9929 38.939 29.8516C38.5153 29.6976 38.0467 29.5627 37.5331 29.4472C37.0323 29.3188 36.5316 29.184 36.0309 29.0427C35.5301 28.8887 35.0679 28.6897 34.6442 28.4457C34.2333 28.2018 33.9059 27.8872 33.662 27.502C33.4309 27.104 33.3346 26.5968 33.3731 25.9805C33.4116 25.0946 33.8289 24.4013 34.6249 23.9005C35.4338 23.3998 36.4738 23.1494 37.7449 23.1494C38.4896 23.1494 39.183 23.2842 39.8249 23.5539C40.4669 23.8235 40.9805 24.2279 41.3657 24.7672C41.7509 25.3065 41.9435 25.9805 41.9435 26.7894H40.3835C40.3835 26.34 40.2872 25.9805 40.0946 25.7109C39.902 25.4284 39.658 25.2102 39.3627 25.0561C39.0674 24.902 38.7593 24.7993 38.4383 24.7479C38.1173 24.6837 37.8284 24.6516 37.5716 24.6516C36.8398 24.6516 36.2363 24.7865 35.7612 25.0561C35.299 25.3257 35.0679 25.6916 35.0679 26.1539C35.0551 26.5647 35.177 26.8921 35.4338 27.1361C35.6906 27.38 36.0309 27.5726 36.4546 27.7139C36.8783 27.8551 37.3405 27.9835 37.8412 28.099C38.3548 28.2146 38.862 28.343 39.3627 28.4842C39.8763 28.6255 40.3385 28.8181 40.7494 29.062C41.1731 29.2931 41.5005 29.6141 41.7316 30.025C41.9756 30.423 42.0847 30.9302 42.059 31.5465C42.0205 32.1499 41.8086 32.6699 41.4235 33.1065C41.0511 33.5302 40.544 33.8576 39.902 34.0887C39.26 34.3069 38.5282 34.4161 37.7064 34.4161Z" fill="white" />
                                                                    </svg>
                                                                </div>
                                                                <div className='me-2'>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 54 54" fill="none">
                                                                        <path d="M27.0372 53.9259C41.9284 53.9259 54.0001 41.8542 54.0001 26.963C54.0001 12.0717 41.9284 0 27.0372 0C12.1459 0 0.0742188 12.0717 0.0742188 26.963C0.0742188 41.8542 12.1459 53.9259 27.0372 53.9259Z" fill="#627EEA" />
                                                                        <path d="M27.875 6.74121V21.6888L40.5088 27.3342L27.875 6.74121Z" fill="#DDDDDD" />
                                                                        <path d="M27.8758 6.74121L15.2402 27.3342L27.8758 21.6888V6.74121Z" fill="white" />
                                                                        <path d="M27.875 37.0205V47.1771L40.5173 29.6865L27.875 37.0205Z" fill="#DDDDDD" />
                                                                        <path d="M27.8758 47.1771V37.0188L15.2402 29.6865L27.8758 47.1771Z" fill="white" />
                                                                        <path d="M27.875 34.67L40.5088 27.3344L27.875 21.6924V34.67Z" fill="#DDDDDD" />
                                                                        <path d="M15.2402 27.3344L27.8758 34.67V21.6924L15.2402 27.3344Z" fill="#DDDDDD" />
                                                                    </svg>
                                                                </div>
                                                                <span className='fs-4'>ETH/AMPL</span>
                                                            </div>
                                                        </Col>
                                                        <Col lg={6} md={6} xs={4} className='mb-2 text-right'>
                                                            <h5 className='mb-0'>0.07503</h5>
                                                        </Col>
                                                    </Row>
                                                    <Row className='align-items-center'>
                                                        <Col lg={6} md={6} xs={8} className='mb-2'>
                                                            <p className='mb-0 small'>Your pool share:</p>
                                                        </Col>
                                                        <Col lg={6} md={6} xs={4} className='mb-2 text-right'>
                                                            <p className='mb-0 small'>25.12546%</p>
                                                        </Col>
                                                        <Col lg={6} md={6} xs={8} className='mb-2'>
                                                            <p className='mb-0 small'>BUSD:</p>
                                                        </Col>
                                                        <Col lg={6} md={6} xs={4} className='mb-2 text-right'>
                                                            <p className='mb-0 small'>1.12856</p>
                                                        </Col>
                                                        <Col lg={6} md={6} xs={8} className='mb-2'>
                                                            <p className='mb-0 small'>ETH:</p>
                                                        </Col>
                                                        <Col lg={6} md={6} xs={4} className='mb-2 text-right'>
                                                            <p className='mb-0 small'>0.00499999</p>
                                                        </Col>
                                                    </Row>
                                                </Container> */}

                    </Col>

                </Row>
            </div>
            {/* </Col>
                        </Row>
                    </Container>

                </section>
            </div> */}



            {/* ------Transaction Submitted------- */}
            <Modal show={!removedLiquidity ? false : true} backdrop={'static'} keyboard={false} onHide={closeModal} centered>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12}>
                            <div className='text-center'>
                                <div className='mb-3'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="60" viewBox="0 0 112 136" fill="none">
                                        <path d="M40.0625 68L52.8125 80.784L78.3125 55.216M59.096 130.196L74.2097 121.777C94.4481 110.503 107 89.1141 107 65.9004V36.2499C107 33.9285 105.745 31.7896 103.721 30.6622L59.096 5.80439C57.1706 4.73187 54.8294 4.73187 52.904 5.80439L8.27903 30.6622C6.25519 31.7896 5 33.9285 5 36.2499V65.9004C5 89.1141 17.5519 110.503 37.7903 121.777L52.904 130.196C54.8294 131.268 57.1706 131.268 59.096 130.196Z" stroke="#85DEF5" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>

                                <Row className='justify-content-center mb-2'>
                                    <Col lg={10}>
                                        <p className='mb-0'>Transaction completed successfully</p>
                                    </Col>
                                </Row>
                                <div className='mb-3'>Liquidity Removed!</div>

                                <div className='mb-3'>
                                    <Button variant='primary' className='px-5 mb-2 col-lg-6 text-black' onClick={() => closeModal()}>Close</Button><br />
                                    <a variant='default' target='_blank' href={`${web3Config.Explore}/tx/${removedLiquidity}`} className='bg-transparent border-0'>View on Block Explorer</a>
                                </div>

                            </div>
                        </Col>
                    </Row>

                </Modal.Body>

            </Modal>
            {/* ------------- */}


            {/* <Footer bg="bg-primary" /> */}

        </>
    )
}

//  default Removeliquidity;
